var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import merge from 'lodash.merge';
import { applyAlphaColor } from '../utils/tools';
import { Modifiers } from './getModifiers';
var getSpacing = function (theme, spacing, getSpacingNumber) { return (getSpacingNumber === null || getSpacingNumber === void 0 ? void 0 : getSpacingNumber(theme.spacing[spacing])) || theme.spacing[spacing] || 0; };
export var buildMarginsProps = function (margins, getSpacingNumber) {
    var theme = margins.theme, mBottom = margins.mBottom, mTop = margins.mTop, mLeft = margins.mLeft, mRight = margins.mRight, mx = margins.mx, my = margins.my;
    return "\n    ".concat(mBottom ? "margin-bottom: ".concat(theme.spacing[mBottom] || 0, "px;") : '', "\n    ").concat(mTop ? "margin-top: ".concat(theme.spacing[mTop] || 0, "px;") : '', "\n    ").concat(mLeft ? "margin-left: ".concat(theme.spacing[mLeft] || 0, "px;") : '', "\n    ").concat(mRight ? "margin-right: ".concat(theme.spacing[mRight] || 0, "px;") : '', "\n    ").concat(mx ? "margin: 0 ".concat(getSpacing(theme, mx, getSpacingNumber), "px ") : '', "\n    ").concat(my ? "margin: ".concat(getSpacing(theme, my, getSpacingNumber), "px 0") : '', "\n ");
};
export var buildPaddingProps = function (paddings, getSpacingNumber) {
    var theme = paddings.theme, pBottom = paddings.pBottom, pTop = paddings.pTop, pLeft = paddings.pLeft, pRight = paddings.pRight, px = paddings.px, py = paddings.py;
    return "\n  ".concat(px ? "padding-left: ".concat(getSpacing(theme, px, getSpacingNumber), "px;") : '', "\n  ").concat(px ? "padding-right: ".concat(getSpacing(theme, px, getSpacingNumber), "px;") : '', "\n  ").concat(py ? "padding-top: ".concat(getSpacing(theme, py, getSpacingNumber), "px;") : '', "\n  ").concat(py ? "padding-bottom: ".concat(getSpacing(theme, py, getSpacingNumber), "px;") : '', "\n  ").concat(pBottom
        ? "padding-bottom: ".concat(getSpacing(theme, pBottom, getSpacingNumber), "px;")
        : '', "\n  ").concat(pTop ? "padding-top: ".concat(getSpacing(theme, pTop, getSpacingNumber), "px;") : '', "\n  ").concat(pLeft
        ? "padding-left: ".concat(getSpacing(theme, pLeft, getSpacingNumber), "px;")
        : '', "\n  ").concat(pRight
        ? "padding-right: ".concat(getSpacing(theme, pRight, getSpacingNumber), "px;")
        : '', "\n ");
};
function getValueByTheme(value, property) {
    if (value) {
        if (typeof value === 'number' || !!Number(value))
            return "".concat(value, "px");
        if (property[value]) {
            return "".concat(property[value], "px");
        }
        return value;
    }
    return '';
}
export var buildPositionProps = function (positions) {
    var theme = positions.theme, props = __rest(positions, ["theme"]);
    var position = '';
    Object.keys(props).forEach(function (key) {
        position += "".concat(key, ": ").concat(getValueByTheme(props[key], theme.spacing), ";");
    });
    return position;
};
export var buildBorderProps = function (border) {
    var theme = border.theme, bRadius = border.bRadius, bWidth = border.bWidth, bColor = border.bColor, _a = border.bStyle, bStyle = _a === void 0 ? 'solid' : _a, _b = border.hasError, hasError = _b === void 0 ? false : _b, _c = border.errorBColor, errorBColor = _c === void 0 ? theme.brand.color.negative.pure : _c;
    var borderRadius = getValueByTheme(bRadius, theme.borderRadius);
    var borderWidth = getValueByTheme(bWidth, theme.borderWidth);
    var borderColor = !hasError ? bColor : errorBColor;
    return "\n  ".concat("border-radius: ".concat(borderRadius, ";"), "\n  ").concat("border-width: ".concat(borderWidth, ";"), "\n  ").concat(borderColor ? "border-color: ".concat(borderColor, ";") : '', "\n  ").concat(bStyle && bWidth ? "border-style: ".concat(bStyle, ";") : '', "\n  ");
};
export var buildFontProps = function (font) {
    var theme = font.theme, fontSize = font.fontSize, fontWeight = font.fontWeight, lineHeight = font.lineHeight, _a = font.fontStyle, fontStyle = _a === void 0 ? 'normal' : _a;
    var formattedFontSize = getValueByTheme(fontSize, theme.fontSize);
    var formattedFontWeight = String(getValueByTheme(fontWeight, theme.brand.fontWeight))
        .replace('px', '')
        .replace('%', '');
    var formattedLineHeight = getValueByTheme(lineHeight, theme.brand.lineHeight);
    return "\n  ".concat("font-size: ".concat(formattedFontSize, ";"), "\n  ").concat("font-weight: ".concat(formattedFontWeight, ";"), "\n  ").concat("line-height: ".concat(formattedLineHeight, ";"), "\n  ").concat("font-style: ".concat(fontStyle, ";"), "\n  ");
};
export var buildSpacingProps = function (args) {
    var theme = args.theme, mBottom = args.mBottom, mTop = args.mTop, mLeft = args.mLeft, mRight = args.mRight, pBottom = args.pBottom, pTop = args.pTop, pLeft = args.pLeft, pRight = args.pRight, px = args.px, py = args.py, mx = args.mx, my = args.my;
    var marginsConstructorArgs = {
        theme: theme,
        mBottom: mBottom,
        mTop: mTop,
        mLeft: mLeft,
        mRight: mRight,
        mx: mx,
        my: my,
    };
    var paddingsConstructorArgs = {
        theme: theme,
        pBottom: pBottom,
        pTop: pTop,
        pLeft: pLeft,
        pRight: pRight,
        px: px,
        py: py,
    };
    return "\n    ".concat(buildMarginsProps(marginsConstructorArgs), "\n    ").concat(buildPaddingProps(paddingsConstructorArgs), "\n  ");
};
export var buildSizeProps = function (args) {
    var theme = args.theme, props = __rest(args, ["theme"]);
    var validProps = Modifiers.getOnlyKeysProps(props, Modifiers.allAcceptableProps.sizes);
    var sizes = '';
    Object.keys(validProps).forEach(function (unsanitizedKey) {
        if (!validProps[unsanitizedKey])
            return;
        var key = Modifiers.transformKeyFromCSSInJSToCSS(unsanitizedKey);
        sizes += "".concat(key, ": ").concat(getValueByTheme(validProps[unsanitizedKey], theme.spacing), ";");
    });
    return sizes;
};
export var buildColorProps = function (args) {
    var bgColor = args.bgColor, labelColor = args.labelColor, bgOpacity = args.bgOpacity, color = args.color;
    var currentColor = labelColor || color;
    return "\n    ".concat(bgColor
        ? "background-color: ".concat(bgOpacity ? applyAlphaColor(bgColor, bgOpacity) : bgColor, ";")
        : '', ";\n    ").concat(currentColor ? "color: ".concat(currentColor, ";") : '', ";\n  ");
};
export var buildDefaultProps = function (devProps, defaultProps) {
    var props = __assign({}, defaultProps);
    Object.entries(defaultProps).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (devProps[key] && typeof devProps[key] !== undefined) {
            if (typeof devProps[key] === 'object') {
                var newObj = buildDefaultProps(devProps[key], value);
                if (Object.keys(newObj).length > 0) {
                    props[key] = newObj;
                }
                return;
            }
            props[key] = devProps[key];
        }
    });
    return props;
};
export var buildFlexboxProps = function (props) {
    var _a = Modifiers.getOnlyKeysProps(props, Modifiers.LAYOUT_KEYS.flexboxKeys), flexDir = _a.flexDir, align = _a.align, justify = _a.justify, wrap = _a.wrap, basis = _a.basis, grow = _a.grow, shrink = _a.shrink, rest = __rest(_a, ["flexDir", "align", "justify", "wrap", "basis", "grow", "shrink"]);
    var styles = {
        flexDirection: flexDir,
        alignItems: align,
        justifyContent: justify,
        flexWrap: wrap,
        flexBasis: basis,
        flexGrow: grow,
        flexShrink: shrink,
    };
    var flexbox = Object.assign(styles, rest);
    return Modifiers.getCssProperties(flexbox);
};
export var buildDivProps = function (props) {
    var div = Modifiers.getOnlyKeysProps(props, Modifiers.LAYOUT_KEYS.divKeys);
    return Modifiers.getCssProperties(div);
};
/** Função para abstrair o merge das props que o dev passa com as default, prevalecendo as props do dev */
export var buildDevProps = function (defaultProps, devProps) { return merge(defaultProps, devProps); };
